/**
 * Avise-me (back in stock) — spec 0133 / ADR-101.
 * API global: window.GmNotify { subscribe, status, open }.
 *
 * Grava pelo form nativo `customer` (/contact): cria/atualiza o cliente com
 * consentimento de marketing e tags `avise-me`, `avise-me-v<variantId>`,
 * `avise-me-p<productId>`. Shopify Flow dispara o aviso na reposição.
 * Cliente que já existe não é alterado pela Shopify: por isso vai também uma
 * cópia pelo form `contact` (e-mail da loja).
 *
 * O POST exige token hCaptcha: o form passa por Shopify.captcha.protect e
 * envia por fetch (a página não navega). Se a Shopify devolver
 * /challenge, reenviamos em página cheia para a cliente resolver o desafio.
 */
(function () {
  const TAG = 'avise-me';
  const STORE_KEY = 'gm-notify:v1';
  const PENDING_KEY = 'gm-notify:pending';
  const SUBMIT_TIMEOUT_MS = 120000;

  function readBoot() {
    const el = document.getElementById('gm-wishlist-boot');
    try {
      return JSON.parse((el && el.textContent) || '{}');
    } catch (e) {
      return {};
    }
  }

  const boot = readBoot();

  function readStore() {
    try {
      return JSON.parse(localStorage.getItem(STORE_KEY) || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  function remember(variantId, email) {
    try {
      const all = readStore();
      all[String(variantId)] = email;
      localStorage.setItem(STORE_KEY, JSON.stringify(all));
    } catch (e) {}
  }

  function forget(variantId) {
    try {
      const all = readStore();
      delete all[String(variantId)];
      localStorage.setItem(STORE_KEY, JSON.stringify(all));
    } catch (e) {}
  }

  function isEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value || '');
  }

  /* Form `customer` só adiciona tag: cancelar marca `avise-me-cancelado-v<id>`
     e o Shopify Flow remove as duas (spec 0133). */
  function customerFields({ variantId, productId, email, action }) {
    const tags =
      action === 'cancel'
        ? [`${TAG}-cancelado`, `${TAG}-cancelado-v${variantId}`]
        : [TAG, `${TAG}-v${variantId}`];
    if (productId && action !== 'cancel') tags.push(`${TAG}-p${productId}`);
    return {
      form_type: 'customer',
      utf8: '\u2713',
      'contact[email]': email,
      'contact[tags]': tags.join(','),
    };
  }

  /* Cópia para a caixa da loja: o form `customer` não altera cliente que já existe. */
  function contactFields({ variantId, productId, email, title }) {
    return {
      form_type: 'contact',
      utf8: '\u2713',
      'contact[email]': email,
      'contact[Assunto]': 'Avise-me (produto esgotado)',
      'contact[Produto]': title || '',
      'contact[Variante]': String(variantId),
      'contact[Produto ID]': String(productId || ''),
      'contact[Página]': window.location.origin + window.location.pathname,
      'contact[body]': `Avise-me: ${title || 'produto'} (variante ${variantId}) - ${email}`,
    };
  }

  function buildForm(fields) {
    const form = document.createElement('form');
    form.method = 'post';
    form.action = '/contact#gm-notify';
    form.acceptCharset = 'UTF-8';
    form.hidden = true;
    Object.keys(fields).forEach((name) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = fields[name];
      form.appendChild(input);
    });
    return form;
  }

  function submitProtected(form) {
    const captcha = window.Shopify && window.Shopify.captcha;
    if (captcha && typeof captcha.protect === 'function') {
      captcha.protect(form, () => form.requestSubmit());
    } else {
      form.submit();
    }
  }

  function submitTopLevel(sub) {
    try {
      sessionStorage.setItem(PENDING_KEY, JSON.stringify(sub));
    } catch (e) {}
    const form = buildForm(customerFields(sub));
    document.body.appendChild(form);
    submitProtected(form);
  }

  function classify(url) {
    if (url.indexOf('/challenge') !== -1) return { ok: false, error: 'challenge' };
    if (/(customer|contact)_posted=true/.test(url)) return { ok: true };
    return { ok: false, error: 'rejected', url };
  }

  /* O script de captcha da Shopify guarda `form.submit` no protect() e o chama
     com o token já no form: trocar antes do protect() envia via fetch. */
  function postForm(fields) {
    return new Promise((resolve) => {
      const form = buildForm(fields);
      let settled = false;
      const finish = (result) => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        form.remove();
        if (!result.ok) console.warn('[gm-notify]', fields.form_type, result);
        resolve(result);
      };
      const timer = setTimeout(() => finish({ ok: false, error: 'timeout' }), SUBMIT_TIMEOUT_MS);

      form.submit = () => {
        fetch('/contact', {
          method: 'POST',
          body: new URLSearchParams(new FormData(form)),
          credentials: 'same-origin',
          headers: { Accept: 'text/html' },
        })
          .then((res) => {
            const result = classify(res.url || '');
            if (!result.ok && res.status >= 400) result.status = res.status;
            finish(result);
          })
          .catch(() => finish({ ok: false, error: 'network' }));
      };

      document.body.appendChild(form);
      submitProtected(form);
    });
  }

  async function subscribe({ variantId, productId, email, title, website }) {
    const mail = String(email || boot.email || '').trim();
    if (!variantId) return { ok: false, error: 'missing_variant' };
    if (!isEmail(mail)) return { ok: false, error: 'invalid_email' };
    if (website) return { ok: true };
    const sub = {
      variantId: String(variantId),
      productId: productId || '',
      email: mail,
      title: title || '',
    };
    const customer = await postForm(customerFields(sub));
    if (customer.error === 'challenge') {
      submitTopLevel(sub);
      return customer;
    }
    const contact = await postForm(contactFields(sub));
    const result = customer.ok || contact.ok ? { ok: true } : customer;
    if (result.ok) {
      remember(variantId, mail);
      document.dispatchEvent(new CustomEvent('gm:notify-subscribed', { detail: sub }));
    }
    return result;
  }

  async function cancel({ variantId, email }) {
    const mail = String(email || readStore()[String(variantId)] || boot.email || '').trim();
    if (!variantId) return { ok: false, error: 'missing_variant' };
    if (!isEmail(mail)) {
      forget(variantId);
      return { ok: true };
    }
    const sub = { variantId: String(variantId), email: mail, action: 'cancel' };
    const result = await postForm(customerFields(sub));
    if (result.error === 'challenge') {
      submitTopLevel(sub);
      return result;
    }
    if (result.ok) {
      forget(variantId);
      document.dispatchEvent(new CustomEvent('gm:notify-cancelled', { detail: sub }));
    }
    return result;
  }

  async function status(variantId) {
    if (!variantId) return false;
    return Boolean(readStore()[String(variantId)]);
  }

  /* ---------- UI: bloco (PDP inline ou modal) ---------- */

  function setDone(root, done, email) {
    const form = root.querySelector('[data-gm-notify-form]');
    const out = root.querySelector('[data-gm-notify-status]');
    root.classList.toggle('is-done', done);
    root.classList.remove('is-error', 'is-invalid', 'is-loading');
    if (form) form.hidden = done;
    if (out) {
      out.textContent = done
        ? (root.dataset.labelDone || '').replace('__EMAIL__', email || '')
        : '';
    }
    const cancelBtn = root.querySelector('[data-gm-notify-cancel]');
    if (cancelBtn) cancelBtn.hidden = !done;
  }

  function refresh(root) {
    const stored = readStore()[String(root.dataset.variantId || '')];
    setDone(root, Boolean(stored), stored);
  }

  function bindBlock(root) {
    const form = root.querySelector('[data-gm-notify-form]');
    const out = root.querySelector('[data-gm-notify-status]');
    if (!form || root.dataset.gmNotifyBound) return;
    root.dataset.gmNotifyBound = 'true';

    const cancelBtn = root.querySelector('[data-gm-notify-cancel]');
    if (cancelBtn) {
      cancelBtn.addEventListener('click', async () => {
        cancelBtn.disabled = true;
        root.classList.add('is-loading');
        const data = await cancel({ variantId: root.dataset.variantId });
        root.classList.remove('is-loading');
        cancelBtn.disabled = false;
        if (!data.ok) {
          root.classList.add('is-error');
          if (out) out.textContent = root.dataset.labelError || '';
          return;
        }
        setDone(root, false);
        if (out) out.textContent = root.dataset.labelCancelled || '';
      });
    }

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const input = form.querySelector('input[name="email"]');
      const hp = form.querySelector('input[name="website"]');
      const btn = form.querySelector('button[type="submit"]');
      const email = input ? input.value.trim() : '';
      if (!input || !isEmail(email)) {
        root.classList.add('is-error', 'is-invalid');
        if (out) out.textContent = root.dataset.labelErrorEmail || '';
        if (input) input.focus();
        return;
      }
      if (btn) btn.disabled = true;
      root.classList.remove('is-error', 'is-invalid');
      root.classList.add('is-loading');
      const data = await subscribe({
        variantId: root.dataset.variantId,
        productId: root.dataset.productId,
        title: root.dataset.productTitle,
        email,
        website: hp ? hp.value : '',
      });
      root.classList.remove('is-loading');
      if (btn) btn.disabled = false;
      if (data.ok) {
        setDone(root, true, email);
        return;
      }
      root.classList.add('is-error');
      root.classList.toggle('is-invalid', data.error === 'invalid_email');
      if (out) {
        out.textContent =
          data.error === 'invalid_email'
            ? root.dataset.labelErrorEmail || ''
            : root.dataset.labelError || '';
      }
    });
  }

  /* Não-modal (show, não showModal): a top layer esconderia o desafio hCaptcha. */
  let dialog = null;
  let backdrop = null;
  let lastTrigger = null;

  function closeDialog() {
    if (dialog && dialog.open) dialog.close();
  }

  function ensureDialog() {
    if (dialog) return dialog;
    const tpl = document.getElementById('gm-notify-dialog-template');
    if (!tpl) return null;
    backdrop = document.createElement('div');
    backdrop.className = 'gm-notify-backdrop';
    backdrop.hidden = true;
    backdrop.addEventListener('click', closeDialog);
    dialog = document.createElement('dialog');
    dialog.className = 'gm-notify-dialog';
    dialog.setAttribute('aria-modal', 'true');
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'gm-notify-dialog__close cursor-pointer';
    close.setAttribute('aria-label', tpl.dataset.closeLabel || 'Fechar');
    close.textContent = '\u00d7';
    close.addEventListener('click', closeDialog);
    dialog.appendChild(close);
    dialog.appendChild(tpl.content.cloneNode(true));
    dialog.addEventListener('close', () => {
      backdrop.hidden = true;
      if (lastTrigger && lastTrigger.isConnected) lastTrigger.focus({ preventScroll: true });
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && dialog.open) closeDialog();
    });
    document.body.appendChild(backdrop);
    document.body.appendChild(dialog);
    bindBlock(dialog.querySelector('[data-gm-notify]'));
    return dialog;
  }

  function open({ variantId, productId, title }) {
    const inline = document.getElementById('gm-notify');
    if (inline && !inline.hidden && inline.dataset.variantId === String(variantId)) {
      inline.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const input = inline.querySelector('input[name="email"]');
      if (input && !inline.classList.contains('is-done')) input.focus({ preventScroll: true });
      return;
    }
    const dlg = ensureDialog();
    if (!dlg) return;
    const root = dlg.querySelector('[data-gm-notify]');
    root.dataset.variantId = String(variantId || '');
    root.dataset.productId = String(productId || '');
    root.dataset.productTitle = title || '';
    const name = root.querySelector('[data-gm-notify-product]');
    if (name) name.textContent = title || '';
    refresh(root);
    backdrop.hidden = false;
    dlg.show();
    const input = root.querySelector('input[name="email"]');
    if (input && !root.classList.contains('is-done')) input.focus();
  }

  document.addEventListener(
    'click',
    (e) => {
      const trigger = e.target instanceof Element ? e.target.closest('[data-gm-notify-open]') : null;
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      lastTrigger = trigger;
      open({
        variantId: trigger.dataset.variantId,
        productId: trigger.dataset.productId,
        title: trigger.dataset.productTitle,
      });
    },
    true
  );

  /* ---------- PDP: ATC <-> Avise-me na troca de tamanho (spec 0072) ---------- */

  function setAtcMode(btn, variantId, available) {
    const text = btn.querySelector('[data-gm-atc-text]');
    const isReal = btn.name === 'add';
    if (available) {
      btn.removeAttribute('data-gm-notify-open');
      if (isReal) btn.type = 'submit';
      if (text && btn.dataset.labelAtc) text.textContent = btn.dataset.labelAtc;
      return;
    }
    if (isReal) {
      btn.type = 'button';
      btn.setAttribute('data-gm-notify-open', '');
      btn.dataset.variantId = String(variantId);
    }
    btn.disabled = false;
    btn.setAttribute('aria-disabled', 'false');
    if (text && btn.dataset.labelNotify) text.textContent = btn.dataset.labelNotify;
  }

  document.addEventListener('gm:size-change', (e) => {
    const d = e.detail || {};
    if (!d.variantId) return;
    document
      .querySelectorAll('[data-gm-atc-swap]')
      .forEach((btn) => setAtcMode(btn, d.variantId, Boolean(d.available)));
    const inline = document.getElementById('gm-notify');
    if (inline) {
      inline.dataset.variantId = String(d.variantId);
      inline.hidden = Boolean(d.available);
      refresh(inline);
    }
    syncWhatsappRow(!d.available && Boolean(inline));
  });

  window.GmNotify = { subscribe, cancel, status, open };

  function resumePending() {
    if (window.location.pathname.indexOf('/challenge') !== -1) return;
    let pending = null;
    try {
      pending = JSON.parse(sessionStorage.getItem(PENDING_KEY) || 'null');
      sessionStorage.removeItem(PENDING_KEY);
    } catch (e) {}
    if (pending && window.location.search.indexOf('customer_posted=true') !== -1) {
      if (pending.action === 'cancel') forget(pending.variantId);
      else remember(pending.variantId, pending.email);
    }
  }

  function syncWhatsappRow(hide) {
    document.querySelectorAll('[data-gm-pdp-whatsapp-row]').forEach((row) => {
      row.hidden = hide;
    });
  }

  function init() {
    resumePending();
    document.querySelectorAll('[data-gm-notify]').forEach((root) => {
      bindBlock(root);
      refresh(root);
    });
    const inline = document.getElementById('gm-notify');
    syncWhatsappRow(Boolean(inline) && !inline.hidden);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
